@import (reference) '../../../../../constants/spacing.module.less';

.layout {
  height: auto;
  margin: 0 auto;
  max-width: 1200px;
  overflow: unset;

  & > * {
    overflow: unset;
  }
}

.button-group {
  justify-content: space-between;
  width: 100%;
}

.back-button {
  display: flex;
  gap: @space-4;
  align-items: center;
}

.arrow-icon {
  width: 16px;
  height: 16px;
}

.item-content {
  margin: @space-8 @space-16 @space-16;
}
